import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("brgt_token", data.token);
      localStorage.setItem("brgt_user", JSON.stringify(data.user));
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/logo.webp"
            alt="brgt.ai"
            className="h-12 mx-auto mb-4"
          />
          <h1 className="font-heading text-2xl font-bold text-navy" data-testid="admin-login-title">Admin Login</h1>
          <p className="text-sm text-slate-500 mt-1">brgt.ai Content Management System</p>
        </div>

        <form onSubmit={handleLogin} className="bg-white rounded-2xl border border-slate-100 p-8 shadow-sm" data-testid="admin-login-form">
          <div className="mb-5">
            <label className="block text-sm font-medium text-navy mb-2">Email</label>
            <div className="relative">
              <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="email"
                data-testid="admin-email-input"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="admin@brgt.ai"
                className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-navy/20 focus:border-navy outline-none transition-all"
                required
              />
            </div>
          </div>
          <div className="mb-6">
            <label className="block text-sm font-medium text-navy mb-2">Password</label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="password"
                data-testid="admin-password-input"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Enter password"
                className="w-full pl-10 pr-4 py-3 bg-white border border-slate-200 rounded-lg focus:ring-2 focus:ring-navy/20 focus:border-navy outline-none transition-all"
                required
              />
            </div>
          </div>
          <button
            type="submit"
            data-testid="admin-login-btn"
            disabled={loading}
            className="w-full bg-navy text-white hover:bg-navy-light rounded-full py-3 font-semibold transition-all shadow-lg shadow-blue-900/20 active:scale-95 disabled:opacity-50"
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
          <p className="text-xs text-slate-400 text-center mt-4">Default: admin@brgt.ai / admin123</p>
        </form>
      </div>
    </div>
  );
}
